import {Event} from "../event";

export interface IProvider<T> {
    parse(data: Event): T;

    send(data: T): void;
}

export abstract class Provider<T> implements IProvider<T> {
    /* STATIC */

    /* INSTANCE */
    abstract parse(data: Event): T;

    abstract send(data: T): void;

}
